/**
 * @internal
 * Internal reference for the render function
 */export const SLOT_RENDER_FUNCTION_SYMBOL = Symbol.for('fui.slotRenderFunction');
/**
 * @internal
 * Internal reference for the render function
 */
export const SLOT_ELEMENT_TYPE_SYMBOL = Symbol.for('fui.slotElementType');